// extracted by mini-css-extract-plugin
module.exports = {"popup_class":"HorizontalAlertsOptions_popup_class__1jGYn","var_margin":"HorizontalAlertsOptions_var_margin__12455"};